import { render, staticRenderFns } from "./SpecialrequestList.vue?vue&type=template&id=9dc10282&"
import script from "./SpecialrequestList.vue?vue&type=script&lang=js&"
export * from "./SpecialrequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports